// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/message-square-text.js';

import { paths } from '../generated/message-square-text';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('message-square-text', Original, paths);
